import type { RouteRecordRaw } from 'vue-router'
import heroIconGlobal from '@/assets/icons/hero-logo-global.png'
import heroIconCn from '@/assets/icons/hero-logo-cn.png'
import heroIconEn from '@/assets/icons/hero-logo-en-red.png'
import heroLogo from '@/assets/light/index/pc-logo.png'

import { dictPicDefault, dictPicDnaGlobal } from "@/common/desktopTipsStatic";
import { DictPicDefault } from "@/@types/types";

export class CommonConstants {
  static readonly PHONE_REGEX_SIMPLE: RegExp = /^1\d{10}$/;

  static readonly KE_FU_URL: string = 'https://kf.yingxiong.com/kf2.0/user-center'

  static readonly IS_AREA: string = process.env.VUE_APP_AREA || 'global'

  static readonly IS_CN: boolean = process.env.VUE_APP_AREA === 'cn'

  static readonly MALL_STATIC_URL: string = 'https://mallstatic.herogame.com/mall-static'

  private static getPrivacyProtocol(): string {
    const PRIVACY_URLS = {
      CN: 'https://www.yingxiong.com/p/per_adu.html',
      GLOBAL: 'https://www.yingxiong.com/p/privacy_globalmall.html'
    };

    const GAME_SPECIFIC_URLS: Record<string, string> = {
      dnaGlobal: 'https://duetnightabyss.herogame.com/en/#/news/content?id=6266'
    };

    if (CommonConstants.IS_CN) {
      return PRIVACY_URLS.CN;
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return GAME_SPECIFIC_URLS[currentGame] ?? PRIVACY_URLS.GLOBAL;
  }

  // 隐私协议
  static get GLOBAL_PRIVACY_PROTOCOL(): string {
    return this.getPrivacyProtocol()
  }

  private static getUserProtocol() {
    const USER_PRIVACY_URLS = {
      CN: 'https://www.yingxiong.com/p/yxyhxy.html',
      GLOBAL: 'https://www.yingxiong.com/p/service_globalmall.html'
    };

    const GAME_SPECIFIC_URLS: Record<string, string> = {
      dnaGlobal: 'https://duetnightabyss.herogame.com/en/#/news/content?id=6268'
    };

    if (CommonConstants.IS_CN) {
      return USER_PRIVACY_URLS.CN;
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return GAME_SPECIFIC_URLS[currentGame] ?? USER_PRIVACY_URLS.GLOBAL;
  }

  // 用户协议
  static get GLOBAL_USER_PROTOCOL(): string {
    return this.getUserProtocol()
  }

  static readonly GLOBAL_JOIN_US: string =
    process.env.VUE_APP_AREA === 'global'
      ? 'https://app.mokahr.com/social-recruitment/yingxionghr/39426#/'
      : 'https://www.yingxiong.com/p/join.html'


  // header 部分logo
  private static getGameLogoHeader(): string {
    const GAME_LOGO_MAP: Readonly<Record<string, string>> = {
      '/topup': `${CommonConstants.MALL_STATIC_URL}/hero-logo-global.png`,
      '/xxyz': 'https://sdksrv.obs.cn-north-1.myhuaweicloud.com/mall-static/xxyz-280x80.png',
    };

    const gamePath = window.globalRoute?.path
    if (CommonConstants.IS_AREA === 'cn') {
      return GAME_LOGO_MAP[gamePath] ?? heroIconCn;
    }

    // 返回对应游戏logo或默认全局logo
    return GAME_LOGO_MAP[gamePath] ?? heroIconGlobal;
  }

  static get GAME_LOGO_HEADER(): string {
    return this.getGameLogoHeader()
  }

  private static getGameLogo() {
    const GAME_LOGO_MAP: Readonly<Record<string, string>> = {
      '/topup': `${CommonConstants.MALL_STATIC_URL}/hero-logo-en-red.png`,
      '/xxyz': 'https://sdksrv.obs.cn-north-1.myhuaweicloud.com/mall-static/xxyz_326x71.png',
    };

    const gamePath = window.globalRoute?.path

    if (CommonConstants.IS_AREA === 'cn') {
      return GAME_LOGO_MAP[gamePath] ?? heroLogo;
    }

    return GAME_LOGO_MAP[gamePath] ?? heroIconEn
  }

  static get GAME_LOGO(): string {
    return this.getGameLogo()
  }

  private static getDefaultRoute() {
    const routeDirectTopup: RouteRecordRaw = {
      path: '/',
      redirect: '/topup'
    }

    const routeDefault: RouteRecordRaw = {
      path: '/',
      name: 'Home',
      component: CommonConstants.IS_CN
      ? () => import('@/views/home/index.vue')
      : () => import('@/views/home/newHome.vue'),
    }

    const routeMap: Record<string, RouteRecordRaw> = {
      dnaGlobal: routeDirectTopup,
      default: routeDefault
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return routeMap[currentGame] ?? routeDefault
  }

  static get DEFAULT_ROUTE(): RouteRecordRaw {
    return this.getDefaultRoute()
  }

  private static getHeaderHeightPC() {
    const HEADER_HEIGHT_PC: Record<string, string> = {
      default: 'h-[58px]',
      dnaGlobal: 'h-[58px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return HEADER_HEIGHT_PC[currentGame] ?? HEADER_HEIGHT_PC.default;
  }

  static get HEADER_HEIGHT_PC(): string {
    return this.getHeaderHeightPC()
  }

  private static getHeaderHeightMobile() {
    const HEADER_HEIGHT_MOBILE: Record<string, string> = {
      default: 'h-[44px]',
      dnaGlobal: 'h-[44px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return HEADER_HEIGHT_MOBILE[currentGame] ?? HEADER_HEIGHT_MOBILE.default;
  }

  static get HEADER_HEIGHT_MOBILE(): string {
    return this.getHeaderHeightMobile()
  }

  private static getHeaderLogoHeightPC() {
    const HEADER_LOGO_HEIGHT_PC: Record<string, string> = {
      default: 'h-[40px]',
      dnaGlobal: 'h-[40px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return HEADER_LOGO_HEIGHT_PC[currentGame] ?? HEADER_LOGO_HEIGHT_PC.default;
  }

  static get HEADER_LOGO_HEIGHT_PC(): string {
    return this.getHeaderLogoHeightPC()
  }

  private static getHeaderLogoHeightMobile() {
    const HEADER_LOGO_HEIGHT_MOBILE: Record<string, string> = {
      default: 'h-[24px]',
      dnaGlobal: 'h-[24px]'
    }

    if (CommonConstants.IS_CN) {
      return 'h-[28px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return HEADER_LOGO_HEIGHT_MOBILE[currentGame] ?? HEADER_LOGO_HEIGHT_MOBILE.default;
  }

  static get HEADER_LOGO_HEIGHT_MOBILE(): string {
    return this.getHeaderLogoHeightMobile()
  }

  private static getFooterLogoHeightPC() {
    const FOOTER_LOGO_HEIGHT_PC: Record<string, string> = {
      default: 'h-[50px]',
      dnaGlobal: 'h-[50px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return FOOTER_LOGO_HEIGHT_PC[currentGame] ?? FOOTER_LOGO_HEIGHT_PC.default;
  }

  static get FOOTER_LOGO_HEIGHT_PC(): string {
    return this.getFooterLogoHeightPC()
  }

  private static getFooterLogoHeightMobile() {
    const FOOTER_LOGO_HEIGHT_MOBILE: Record<string, string> = {
      default: 'w-[85px]',
      dnaGlobal: 'w-[85px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return FOOTER_LOGO_HEIGHT_MOBILE[currentGame] ?? FOOTER_LOGO_HEIGHT_MOBILE.default;
  }

  static get FOOTER_LOGO_HEIGHT_MOBILE(): string {
    return this.getFooterLogoHeightMobile()
  }

  private static getLoginLogoHeightPC() {
    const LOGIN_LOGO_HEIGHT_PC: Record<string, string> = {
      default: 'h-[51px]',
      dnaGlobal: 'h-[51px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return LOGIN_LOGO_HEIGHT_PC[currentGame] ?? LOGIN_LOGO_HEIGHT_PC.default;
  }

  static get LOGIN_LOGO_HEIGHT_PC(): string {
    return this.getLoginLogoHeightPC()
  }

  private static getLoginLogoHeightMobile() {
    const LOGIN_LOGO_HEIGHT_MOBILE: Record<string, string> = {
      default: 'h-[41px]',
      dnaGlobal: 'h-[41px]'
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return LOGIN_LOGO_HEIGHT_MOBILE[currentGame] ?? LOGIN_LOGO_HEIGHT_MOBILE.default;
  }

  static get LOGIN_LOGO_HEIGHT_MOBILE(): string {
    return this.getLoginLogoHeightMobile()
  }

  private static getDeskTopTipsPic(): DictPicDefault {
    const DESKTOP_TIPS_PIC: Record<string, DictPicDefault> = {
      default: dictPicDefault,
      dnaGlobal: dictPicDnaGlobal
    }

    const currentGame = process.env.VUE_APP_GAME || 'default';

    return DESKTOP_TIPS_PIC[currentGame] ?? DESKTOP_TIPS_PIC.default;
  }

  static get DESKTOP_TIPS_PIC(): DictPicDefault {
    return this.getDeskTopTipsPic()
  }

  private static readonly FOOTER_DICT_LIST_DEFAULT = [
    { text: '津ICP备17005823号-4', label: 'i18n-kekao' },
    { text: '增值电信业务经营许可证：津B2-20160025', label: 'i18n-gaoxiao' },
    { text: 'COPYRIGHT©2015 – 2026 . ALL RIGHTS RESERVED.', label: 'i18n-bianjie' },
    { text: '英雄游戏版权所有  ©2015-2026中国网络游戏版权保护联盟举报中心', label: 'i18n-youhui' }
  ]

  private static readonly FOOTER_DICT_LIST_XXYZ = [
    { text: '粤ICP备2023011480号-1', label: 'i18n-kekao' },
    { text: '经营许可证编号:粤B2-20240837', label: 'i18n-gaoxiao' },
  ]

  private static getFooterDictList() {
    const FOOTER_DICT_MAP: Readonly<Record<string, typeof CommonConstants.FOOTER_DICT_LIST_DEFAULT>> = {
      '/xxyz': CommonConstants.FOOTER_DICT_LIST_XXYZ,
    }

    const gamePath = window.globalRoute?.path
    return FOOTER_DICT_MAP[gamePath] ?? CommonConstants.FOOTER_DICT_LIST_DEFAULT
  }

  static get FOOTER_DICT_LIST() {
    return this.getFooterDictList()
  }

  private static getJoinUsUrl() {
    const defaultUrl = "https://www.hero.com/p/join.html"
    const JOIN_US_URL: Record<string, string> = {
      '/xxyz': ""
    }

    const gamePath = window.globalRoute?.path

    return JOIN_US_URL[gamePath] ?? defaultUrl
  }

  static get JOIN_UR_URL() {
    return this.getJoinUsUrl()
  }

  private static getKefuUrl() {
    const defaultUrl = "https://www.hero.com/p/contact.html"
    const KE_FU_URL: Record<string, string> = {
      '/xxyz': "https://kf.zealshow.com/kf2.0/user-center?game_id=2334&lang=zh"
    }

    const gamePath = window.globalRoute?.path

    return KE_FU_URL[gamePath] ?? defaultUrl
  }

  static get CONNECT_US_URL() {
    return this.getKefuUrl()
  }

  private static getPriUrl() {
    const defaultUrl = "https://www.hero.com/p/per_adu.html"
    const PRI_URL: Record<string, string> = {
      '/xxyz': "https://pa.zealshow.com/PersonalProtectionPolicy.html"
    }

    const gamePath = window.globalRoute?.path

    return PRI_URL[gamePath] ?? defaultUrl
  }

  static get PRI_URL() {
    return this.getPriUrl()
  }
}
